module.exports = __webpack_public_path__ + "assets/img/avatar.c4ff21ed.jpg";